import {Button} from 'antd';
import {useState} from 'react';

import data from '../../data/product.json';

const categories = ['All', ...data.categories];
const products = data.products;

const ProductPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredProducts =
    selectedCategory === 'All'
      ? products
      : products.filter(p => p.category === selectedCategory);

  return (
    <div className={'w-full flex flex-col justify-center  items-center lg:px-20 px-5 lg:py-20 py-10 '}>
      <div className={'max-w-7xl w-full'}>
        {/* Heading */}
        <h1 className={'playfair-display-medium  text-4xl lg:text-6xl font-bold mb-8 text-primary-900'} data-aos={'fade-down'}
        >
        Our Furniture Collection
        </h1>

        {/* Filter Buttons */}
        <div className={'flex gap-3 mb-6 flex-wrap justify-start'} 
        >
          {categories.map(category => (
            <Button
              key={category}
              className={`px-4 py-2 rounded font-medium transition-all border border-primary-500 ${
                selectedCategory === category
                  ? '!bg-primary-500 !text-white border border-primary-500'
                  : 'bg-white'
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        <div className={'grid lg:grid-cols-3 grid-cols-1 gap-6 justify-items-start'}>
          {filteredProducts.map(product => (
            <div
              key={product.id}
              className={
                'shadow-md rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300 bg-white w-full'
              }
            >
              <div className={'w-full h-72'}>
                <img
                  src={product.image}
                  alt={product.name}
                  className={'w-full h-full object-cover'}
                />
              </div>
              <div className={'p-4'}>
                <h2 className={'text-xl font-bold text-primary-900'}>{product.name}</h2>
                <p className={'text-gray-600 mt-1'}>{product.description}</p>
              </div>
            </div>
          ))}

          {filteredProducts.length === 0 && (
            <p className={'col-span-full text-left text-gray-500 mt-10'}>
      No products found in this category.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
